 import packageJson from 'package.json';
 
 export const environment: any = {
    version: packageJson.version,
    VERSION: packageJson.version,
    API_ENDPOINT: 'https://wg2-api.elements-eng.cloud:42443/api/v1',
    API_URL: 'https://wg2-api.elements-eng.cloud:42443/api/v1/datastructures',
    API_STATIC_FILE_UPLOAD: 'https://eng-upload.q9elements.com:11443/api',
    APPNAME: 'HD-APP',
    ANALYSIS_API: 'https://dev-gateway.q9elements.com/automation-us-dependency-analysis/api/v1/dependency-analysis',
    CHANGELOG_APP_URL: 'https://wg2-changelogs.elements-eng.cloud',
    CLOUD_NAME: 'elements',
    CLOUD_TYPE: 'public',
    DATA_STRUCTURE_URL: 'https://wg2-datatable.elements-eng.cloud',
    DE_APP_URL: 'https://wg2-diagram.elements-eng.cloud',
    DE_APP: 'https://wg2-diagram.elements-eng.cloud',
    DIAGRAM_URL: 'https://wg2-diagram.elements-eng.cloud',
    DOMAIN: 'elements-eng.cloud',
    ENTERPRISE_URL: 'https://wg2-corp.elements-eng.cloud',
    ENV: 'wg2',
    GDPR_SUPPORT_LINK: 'https://support.elements.cloud/en/articles/1221094-enable-data-privacy-gdpr-compliance-for-a-ref-model',
    HELP_LINK: 'https://support.elements.cloud/',
    IMPORT_MAP_API: 'https://dev-gateway.q9elements.com/wg2-map-import/api/v1',
    IMPORTS_API: 'https://dev-gateway.q9elements.com/wg2-import/api/v1',
    INTERCOM_APP_ID: 'c2s7te3m',
    INTERCOM_URL: 'string',
    MAIN_APP_URL: 'https://wg2.elements-eng.cloud',
    MAIN_APP: 'https://wg2.elements-eng.cloud',
    MAP_MANAGEMENT_APP: 'https://wg2-mapmgt.elements-eng.cloud',
    NO_IMAGE_URL: '../../assets/images/no_image.png',
    NOUI: false,
    PARTNER_APP: 'https://wg2-partnermgt.elements-eng.cloud',
    PREVIEW_HOLDER: '/assets/images/map_placeholder.png',
    production: true,
    PX_KEY: 'AP-3EN4L67VSTXG-2-3',
    RAVEN_DSN: 'https://eb6892047d9b42638a7563ddb26386ea@sentry.io/1233470',
    RAVEN_ID: '9e76fe14aaba4a31846fe607572f9eb1',
    REF_MODEL_APP: 'https://wg2-refmodel.elements-eng.cloud',
    RELEASE_URL: 'https://wg2-releasemgt.elements-eng.cloud',
    REMOTE_UNLOCK_TTL: 3600000,
    REPORTS_API_ENDPOINT: 'https://dev-gateway.q9elements.com/wg2-report/api/v1',
    REPORTS_API: 'https://dev-gateway.q9elements.com/wg2-report/api/v1', 
    REPORTS_APP: 'https://wg2-report.elements-eng.cloud',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv_dnSd_YxI3fytEOzEoGYI_S_hYxU0M6h05YDy6p520.5ap1cCcg2g6lxh.O',
    SALESFORCE_REDIRECT_URL: 'https://wg2.elements-eng.cloud/auth/callback',
    SALESFORCE_URL_TEST: 'https://test.salesforce.com/services/oauth2/authorize',
    SALESFORCE_URL: 'https://login.salesforce.com/services/oauth2/authorize',
    SECURE_COOKIES: true,
    SYS_ADMIN_APP: 'https://wg2-sysadmin.elements-eng.cloud',
    TEAM_APP: 'https://wg2-spacemgt.elements-eng.cloud',
    TOASTR_TIMEOUT: 5000,
    UNLOCK_TTL: 180000,
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    fbConfig: {
        apiKey:'AIzaSyC2bgrIEgDdW3TF68B2aRpwb6ad70Aj-Xw',
        authDomain:'elements-wg2-whcn.firebaseapp.com',
        databaseURL: 'https://elements-wg2-whcn-default-rtdb.firebaseio.com',
        projectId: 'elements-wg2-whcn',
        appId: '1:682247410855:web:be4376b040c0f3e8f83782'
    }
}; 
